"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOCK_CREDIT = void 0;
var STOCK_CREDIT = {
  TEXT__SELECTED_PRODUCTS: 'newCreditNoteStockCredit-span-selectedProducts',
  INPUT__SEARCH: 'newCreditNoteStockCredit-input-search',
  TEXT__PRODUCT_NAME: 'newCreditNoteStockCredit-span-productName',
  INPUT__BATCH_ID: 'newCreditNoteStockCredit-input-batchCode',
  INPUT__EXPIRY_DATE: 'newCreditNoteStockCredit-input-expiryDate',
  TEXT__UNIT: 'newCreditNoteStockCredit-span-unit',
  INPUT__QUANTITY: 'newCreditNoteStockCredit-input-quantity',
  INPUT__PRICE: 'newCreditNoteStockCredit-input-price',
  BUTTON__TOGGLE_SELECTED: 'newCreditNoteStockCredit-button-toggleSelected'
};
exports.STOCK_CREDIT = STOCK_CREDIT;